import { dayjs } from '@2wunder/klarx-tool'
import { MemberProps } from 'app/components/Core/convention'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

import { OverviewTableType } from '../Table'

export const groupDateFormat = 'MMMM YYYY' // 'MMMM YYYY' => 'January 2021'

const InvoiceNameCell: React.FC<MemberProps<OverviewTableType>> = ({ member }) => {
  if (member.__typename === 'InvoiceItem') {
    return <InvoiceItemName member={member as IInvoiceItem} />
  } else if (member.__typename === 'Invoice') {
    return <InvoiceName member={member as IInvoice} />
  } else if (member.__typename === 'InvoiceGroup') {
    return <InvoiceGroupName member={member as IInvoiceGroup} />
  }
  return <></>
}

function InvoiceName({ member }: MemberProps<IInvoice>) {
  const { tRecordType } = useTranslation({ recordType: RecordType.invoice })
  return (
    <>
      <span className="text-bold">{`${tRecordType({})}: ${member.invoiceNumber}`}</span>
      <br />
      <span className="ml-4 text-muted">
        {member.rental?.rentalCode} - {member.project?.name}
      </span>
    </>
  )
}

function InvoiceItemName({ member }: MemberProps<IInvoiceItem>) {
  return <>{member.name}</>
}

function InvoiceGroupName({ member }: MemberProps<IInvoiceGroup>) {
  return <span className="text-bold">{dayjs(member.key).format(groupDateFormat)}</span>
}

export default InvoiceNameCell
